function e(e){return function(n){for(let t in n)e(t)||delete n[t]}}export{e as shouldForwardProp};
